__webpack_require__.p = "https://assets.airtel.in/static-assets/self-kyc/";